import { html } from 'lit';
import { CrntElement } from '../../lib/crnt-element.js';
import { trustedCSS } from '../../lib/css/css.js';
import formControlLabelIndicatorStyles from './form-control-label-indicator.css.js';

class CrntFormControlLabelIndicator extends CrntElement {
  static {
    this.styles = trustedCSS(formControlLabelIndicatorStyles);
  }
  static {
    this.tagName = "crnt-form-control-label-indicator";
  }
  render() {
    return html`<slot class="crnt-form-control-label-indicator" part="indicator"></slot>`;
  }
}

export { CrntFormControlLabelIndicator };
